import React from 'react';
import { Box, Typography } from '@material-ui/core';

const FallbackWarning = (props) => (
  <Box
    display="flex"
    alignItems="center"
    gap={1.5}
    py={1.5}
    px={2}
    bgcolor="#f5f5f5"
    borderRadius={2}
    border="1px solid #e0e0e0"
    mb={2}
    {...props}
  >
    <Box
      width={20}
      height={20}
      bgcolor="#bdbdbd"
      borderRadius="50%"
      display="flex"
      alignItems="center"
      justifyContent="center"
      flexShrink={0}
    >
      <Typography variant="caption" style={{ color: 'white', fontWeight: 'bold' }}>
        !
      </Typography>
    </Box>
    <Box flex={1}>
      <Box width="60%" height={8} bgcolor="#e0e0e0" borderRadius={4} />
    </Box>
  </Box>
);

export default FallbackWarning;
